import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '@lohi/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InternalGuard implements CanActivate {
  constructor(private httpClient: HttpClient, private router: Router, private logger: NGXLogger) {}
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.httpClient.get<{ internal: boolean }>(`${environment.api}/v1/internal/is_internal`).pipe(
      map((response) => {
        if (response.internal) {
          return true;
        }
        return this.router.parseUrl('/auth/login');
      }),
      catchError((error) => {
        this.logger.error(error);
        return of(this.router.parseUrl('/auth/login'));
      }),
    );
  }
}
